import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const KeySkillsCard = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const {
    inc_skills,
    inc_keyskills,
    inc_skillscategories,
    inc_skillslevel,
    inc_skillskillsexperience,
    inc_skillslastused,
    inc_skillsdescriptions,
    inc_skillsleveldescriptions,
  } = state

  return (
    <CVCard
      title={t('CVTemplates.KeySkills')}
      description={t('CVTemplates.PersonKeySkills')}
      isEnabled={inc_skills}
      toggleName='inc_skills'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox name='inc_keyskills' label={t('CVTemplates.KeySkillsOnly')} value={inc_keyskills} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillscategories'
          label={t('CVTemplates.ShowCategories')}
          value={inc_skillscategories}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillslevel'
          label={t('CVTemplates.ShowSkillLevel')}
          value={inc_skillslevel}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillskillsexperience'
          label={t('CVTemplates.ShowExperienceTime')}
          value={inc_skillskillsexperience}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_skillslastused'
          label={t('CVTemplates.ShowLastUsed')}
          value={inc_skillslastused}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      {/* <Grid item>
        <OPCheckBox
          name='inc_skillsdescriptions'
          label={t('CVTemplates.ShowPersonSkillDescriptions')}
          value={inc_skillsdescriptions}
          onChangeState={handleSwitchChange}
        />
      </Grid> */}
      <Grid item>
        <OPCheckBox
          name='inc_skillsleveldescriptions'
          label={t('CVTemplates.ShowSkillLevelDescriptions')}
          value={inc_skillsleveldescriptions}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
